import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './authFlow.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { AuthFlow } from "model/contract/authFlow.model";

export interface AuthFlowDetailsProps extends DetailsStateAndDispatchProps<AuthFlow>,
  RouteComponentProps, StateProps, DispatchProps {
}
const AuthFlowDetails: FC<AuthFlowDetailsProps> = (props) => {
  return (
    <DetailsPage<AuthFlow>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<AuthFlow>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ authFlow }: RootState) => ({
  entity: authFlow.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(AuthFlowDetails);
